module.exports = __webpack_public_path__ + "img/investigate.1d2508f1.png";